/**
 * A global namespace for 'animationName' string.
 */
const animationName = 'animationName';
export default animationName;
